import type { NestedKeys } from '../../types.ts';

/**
 * `en` · `gallery` namespace — generated media: image/video generation
 * requests, job status, and the media grid.
 */
export const gallery = {
  title: 'Gallery',
  empty: 'No media yet. Generate your first piece of media.',
  generate: {
    imagePrompt: 'Describe the image',
    videoPrompt: 'Describe the video',
    submit: 'Generate',
  },
  status: {
    queued: 'Queued…',
    generating: 'Generating…',
    ready: 'Ready',
    failed: 'Generation failed. Try again.',
    blocked: 'This request was blocked by our safety filters.',
  },
  actions: {
    download: 'Download',
    delete: 'Delete',
    setAsReference: 'Set as reference photo',
  },
} as const;

export type GalleryMessages = typeof gallery;

/** Typo-safe dot-path keys for the `gallery` namespace. */
export type GalleryKey = NestedKeys<GalleryMessages>;
